module.exports = __webpack_public_path__ + "img/whatsapp.a3665cb4.png";